/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { get } from '../../helpers/api_helper';

function SaleData(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t, reference } = props;

  const [data, setData] = useState(null);
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    try {
      setLoading(true);
      const storeInfo = await get('/api/bc/info');
      const res = await get(`/api/bc/sale/inspect/${reference}`);

      setData(res);
      setInfo(storeInfo);
    } catch (e) {
      toastr.error(t('Error loading BigCommerce sales data'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [reference]);

  const linkStyle = {
    color: '#ffd166',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.35rem',
    marginBottom: '0.75rem',
    fontWeight: 500,
    textDecoration: 'none',
  };

  const iconStyle = {
    fontSize: '1.15rem',
  };

  const jsx = (
    <>
      {data !== null && info !== null && (
        <div>
          <a
            href={`${info.control_panel_base_url}/manage/orders?keywords=${data.id}`}
            target="_blank"
            rel="noreferrer"
            style={linkStyle}
          >
            {t('View on BigCommerce')}
            <span className="bx bx-window-open" style={iconStyle} />
          </a>
          <div />
          <a
            href={`${info.control_panel_base_url}/manage/orders/${data.id}/messages/add`}
            target="_blank"
            rel="noreferrer"
            style={linkStyle}
          >
            {t('Message Customer on BigCommerce')}
            <span className="bx bx-mail-send" style={iconStyle} />
          </a>
        </div>
      )}

      {(data === null || info === null) && (
        <div>
          {loading === true && (
            <p>
              <span className="mdi mdi-spin mdi-loading" />
              {' '}
              {t('Loading...')}
            </p>
          )}

          {loading === false && (
            <p>Could not find order on BigCommerce</p>
          )}
        </div>
      )}
    </>
  );

  return jsx;
}

SaleData.defaultProps = {
  t: (w) => w,
};

SaleData.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  reference: PropTypes.string.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(SaleData));
